import { Check } from "lucide-react";

type Props = {
  className?: string;
  compact?: boolean;
};

/** Små synliga bockar: Fukttestad + Gasoltestad vid leverans. */
export function DeliveryChecks({ className = "", compact = false }: Props) {
  const items = ["Fukttestad", "Gasoltestad"];
  return (
    <div
      className={`flex flex-wrap items-center gap-1.5 ${className}`}
      aria-label="Fukttestad och gasoltestad vid leverans"
      title="Fukttestad + gasoltestad vid leverans"
    >
      {items.map((label) => (
        <span
          key={label}
          className={`inline-flex items-center gap-1 rounded-full border border-emerald-600/25 bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-500/30 font-semibold ${
            compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]"
          }`}
        >
          <Check size={compact ? 9 : 11} strokeWidth={3} className="text-emerald-600 dark:text-emerald-400" />
          {label}
        </span>
      ))}
      <span
        className={`text-muted-foreground ${
          compact ? "text-[9px]" : "text-[10px]"
        }`}
      >
        vid leverans
      </span>
    </div>
  );
}
